import { faLayerGroup } from '@fortawesome/free-solid-svg-icons';

export const PAGE_CONFIG = (tr) => ({
    PAGE_DESCRIPTION: tr('pageDescription'),
    EMPTY_PAGE_ICON: faLayerGroup,
    SEARCH_DESCRIPTION: tr('searchDescription'),
    SEARCH_PLACEHOLDER: tr('searchPlaceholder'),
    SEARCH_LOADING_MESSAGE: tr('searchLoadingMessage')
});
